




































































































































































































































































































































































































































































import Vue from 'vue'
import ElementMixin from './ElementMixin'

export default Vue.extend({
  mixins: [ElementMixin],
})
